import {setupI18n} from '@lingui/core';
import dxEs from 'devextreme/localization/messages/es.json';
import dxEn from 'devextreme/localization/messages/en.json';
import {locale as setLocale, loadMessages} from 'devextreme/localization';
export const i18n2 = setupI18n();
export const DEFAULT_LOCALE = 'es';

loadMessages(dxEs);
loadMessages(dxEn);
setLocale(DEFAULT_LOCALE);

export async function setupLocale(locale, catalog) {
  const safeLocale =
    locale === 'en' || locale === 'es' ? locale : DEFAULT_LOCALE;

  setLocale(safeLocale);
  localStorage.setItem('locale', safeLocale);
  i18n2.load(safeLocale, catalog[safeLocale]);
  i18n2.activate(safeLocale);
}
